<template>
  <v-content>
    <router-view />

    <school-core-footer />
  </v-content>
</template>

<script>
  export default {
    name: 'SchoolCoreView',

    components: {
      SchoolCoreFooter: () => import('./Footer'),
    },
  }
</script>
